<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2 id="label_SetupUserManageUserGroupTitle">{{translate?.general.buttons.select2.singular}} {{translate?.setup.users.users.label.singular}} {{translate?.setup.users.groups.label.singular}}</h2>
        </div>
        <button class="icon-btn" aria-label="Close" id="btn_SetupUserManageUserGroupClose" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="flx-modal__body mp-body">
        <form [formGroup]="userGroupForm">
            <div class="status-field">
                <label class="field-label mandatory" id="label_SetupUserManageUserGroupFieldLabel">{{translate?.setup.users.users.label.singular}} {{translate?.setup.users.groups.label.singular}}</label>
                <div class="field-row field-row--auto">
                    <p-multiSelect
                        formControlName="userGroup"
                        id="picklist_SetupUserManageUserGroupField"
                        [placeholder]="translate?.general.messages.none"
                        [options]="userGroups"
                        optionLabel="name"
                        optionValue="id"
                        [filter]="true"
                        display="chip"
                        appendTo="body"
                        >
                    </p-multiSelect>
                    <div class="p-error text-10" id="label_SetupUserManageUserGroupError"
                        *ngIf="(userGroupForm.controls['userGroup'].touched || submitted) && userGroupForm.controls['userGroup'].invalid">
                        <span id="label_SetupUserManageUserGroupRequiredError" *ngIf="userGroupForm.controls['userGroup'].errors?.required">
                            {{ translate?.general.validationFE.requiredField }}
                        </span>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="flx-modal__footer">
        <button class="custella-btn-white" id="btn_SetupUserManageUserGroupCancel" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        <p-button type="button" styleClass="h-32" [label]="translate?.general.buttons.save.singular" id="btn_SetupUserManageUserGroupSave" (onClick)="onSave()"></p-button>
    </div>
</div>